import { SkyBadge } from "@skypointcloud/skypoint-ui";
import type { StatusPresentation } from "@/components/runs/runFormatting";

/**
 * A table's stage badge (`entityStagePresentation`), with its hover when the stage has words of
 * its own (#2392: "No rows" says the source returned none in this import).
 */
/**
 * #2392 (review): the longest label the Status column's floors were measured for ("Extracted, not
 * loaded"). A longer one ("No rows yet, table not created") may wrap onto a second line inside the
 * column at 1024 px, never run into the next column.
 */
const ONE_LINE_LABEL_MAX = "Extracted, not loaded".length;
const WRAPPING_BADGE = "h-auto min-h-5 whitespace-normal rounded-md py-0.5 text-left leading-tight";

export function StageBadge({ presentation }: { presentation: StatusPresentation }) {
  const wraps = presentation.label.length > ONE_LINE_LABEL_MAX;
  const badge = (
    <SkyBadge
      appearance="tint"
      color={presentation.color}
      {...(wraps ? { className: WRAPPING_BADGE } : {})}
    >
      {presentation.label}
    </SkyBadge>
  );
  if (!presentation.title) return badge;
  return (
    <span title={presentation.title} className="inline-flex">
      {badge}
    </span>
  );
}
